import Fetch from './fetch';
import getCustomLogger from './logger';
import { secondsToMilliseconds } from '../utils';


const logger = getCustomLogger('Polling');

export default class Polling {
  constructor(url, interval, successCallback, errorCallback, counterCallback) {
    this.counterCallback = counterCallback;

    this._pollEnable = false;
    this._url = url;

    this.start = this.start.bind(this);

    this.fetcher = new Fetch(
      url,
      successCallback,
      errorCallback
    );

    this.setInterval(interval);
    this.start();
  }

  /**
   * Set polling interval
   *
   * @param {int} interval
   * @memberof Polling
   */
  setInterval(interval) {
    this.interval = secondsToMilliseconds(interval) || this.interval;
  }

  isPollEnabled() {
    return this._pollEnable;
  }

  /**
   * Start polling interval
   *
   * @memberof Polling
   */
  start() {
    logger.log('Starting polling URL:', this._url);
    this._pollEnable = true;
    let countdownTimer = this.interval / 1000;

    const _countdownCallback = () => {
      this.counterCallback(countdownTimer);

      countdownTimer--;
      if (countdownTimer <= 0) {
        if (this._pollEnable) {
          this.fetcher.request();
        }

        countdownTimer = this.interval / 1000;
      }

      if (this._pollEnable) {
        this._timeout = setTimeout(_countdownCallback, 1000);
      }
    };

    _countdownCallback();
  }

  /**
   * Stop polling interval
   *
   * @memberof Polling
   */
  stop() {
    this._pollEnable = false;
    this._timeout && clearTimeout(this._timeout);
  }
}
